<template>
  <div>
    <add-influencer :is-active.sync="isAdding" @added="influencerAdded" />
    <data-table
      title="Influencers"
      ref="table"
      :url="url"
      :headers="headers"
      searchable
      :csv="true"
      :archive="true"
      @update-archived="(status) => (this.showArchived = status)"
      csvFileName="users.csv"
      :csvFields="csvFields"
      @click:row="showDetails"
      @rowClicked="showDetails"
    >
      <template slot="action.icons">
        <v-btn color="primary" @click="isAdding = true">
          Add Influencer
          <v-icon class="ml-2" color="light-blue lighten-4">
            mdi-account-plus
          </v-icon>
        </v-btn>
      </template>
      <span slot="item.type" slot-scope="{ item }" v-text="getUserType(item)" />

      <template slot="item.status" slot-scope="{ item }">
        <v-icon color="success" v-if="item.is_active">mdi-progress-check</v-icon>
        <v-icon color="warning" v-else>mdi-information-outline</v-icon>
      </template>
    </data-table>
  </div>
</template>
<script>
import { getUserType } from "./utils";
export default {
  components: { AddInfluencer: require("./influencerForm").default },
  data() {
    return {
      currentFilter: "all",
      isAdding: false,
      showArchived: false,
      url: "api/v1/users?is_influencer=true",
      headers: this.pairTableLabelWithValue({
        ID: "id",
        "First Name": "first_name",
        "Last Name": "last_name",
        Email: "email",
        Country: "country",
        "Phone Number": "full_phone_number",
        Type: "type",
        Status: "status",
      }),
      csvFields: [
        {
          label: "Full names",
          value: "full_name",
          default: "",
        },
        {
          label: "Phone number",
          value: "full_phone_number",
          default: "",
        },
        {
          label: "User email",
          value: "email",
          default: "",
        },
        {
          label: "Birth Date",
          value: "birth_date",
          default: "",
        },
        {
          label: "Birth Location",
          value: "birth_location",
          default: "",
        },
        {
          label: "Country",
          value: "country",
          default: "",
        },
        {
          label: "User Type",
          value: "client.type",
          default: "",
        },
        {
          label: "User Status",
          // eslint-disable-next-line no-unused-vars
          value: function (row, field, data) {
            // field = { label, default }
            // data = full data object
            return row.is_active ? "active" : "not active";
          },
          default: "",
        },
        {
          label: "Create Date",
          value: "created_at",
          default: "",
        },
      ],
    };
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
    showArchived: function (val) {
      if (val && val !== "false") {
        this.url = `/api/v1/users/all?is_influencer=true`;
      } else {
        this.url = `/api/v1/users?is_influencer=true`;
      }
    },
  },
  methods: {
    showDetails({ id }) {
      this.$router.push({ name: "users.show", params: { id } });
    },
    getUserType,
    influencerAdded({ message }) {
      this.isAdding = false;
      this.$refs.table.fetchData();
      Notify.success(message);
    },
  },
};
</script>
